import { h, Component } from 'preact';
import s from 'components/core/iframe/iframe.sss';
import { joinClasses } from 'utils/utils';

/**
 * iframe core component
 * @prop {String} class - class you want to give the iframe
 * @prop {String} src - src for the iframe
 * @prop {Boolean} percentageDimensions - should the iframe use percentage based dimensions
 */
export default class Iframe extends Component {

	// TODO: render out the actual iframe when on the server, so it's in the html page?

	constructor() {
		super();
		this.state.loaded = false;
		this.iframe = null;

		this.finishedLoading = this.finishedLoading.bind(this);
		this.tryToLoad = this.tryToLoad.bind(this);
	}

	componentDidMount() {
		if (!this.$wrapper) {
			return;
		}
		//to solve slow loading iframe and duplicate calls preact bug
		// const src = this.props.src;
		const iframe = document.createElement('iframe');
		if (this.props.isIOS && !this.props.scrollable) {
			iframe.scrolling = 'no';
		}
		iframe.onload = this.finishedLoading;
		iframe.className = this.props.class;
		iframe.ariaLabel = this.props.ariaLabel;
		this.tryToLoad(iframe);
		this.$wrapper.appendChild(iframe);
		this.iframe = iframe;
	}

	componentWillReceiveProps(nextProps) {
		if (this.iframe && nextProps.class !== this.props.class) {
			this.iframe.className = nextProps.class || '';
		}
	}

	componentWillUnmount() {
		this.setState({ loaded: false });
		window.clearTimeout(this.loadingTimeout);
	}

	tryToLoad(element) {
		const iframe = element || this.iframe;
		iframe.src = this.props.src;

		this.loadingTimeout = setTimeout(this.tryToLoad, 5000);
	}

	finishedLoading() {
		clearTimeout(this.loadingTimeout);
		// add in timeout so the frame has time to render and animate properly
		this.setState({ loaded: true });
		if (typeof this.props.onLoad === 'function') {
			this.props.onLoad(this.$iframe);
		}
	}

	render(props, { loaded }) {
		let {
			containerClass,
			percentageDimensions,
			loadedClass,
			onLoad,
			src,
			scrollable,
			isIOS,
			...extraProps
		} = props;

		delete extraProps.class;

		const loaderEl = !loaded ? [
			<div class={s.loader} />,
			<div class={s.loaderBg} />
		] : undefined;

		let iosFix = isIOS && (scrollable ? s.scrollable : s.fixed);

		return (
			<div class={joinClasses(s.container, containerClass, loaded && loadedClass)}>
				<div class={joinClasses(s.loaderContainer, !loaded && s.loading)}>
					{loaderEl}
				</div>
				<div class={joinClasses(loaded && loaded, s.loaded, percentageDimensions && s.percentageDimensions, iosFix)} ref={e => this.$wrapper = e} />
			</div>
		);
	}

}
